export default "__VITE_ASSET__Cgh46zJF__"